type HistoryMethod = 'pushState' | 'replaceState';

const emitHistoryChange = () => {
	window.dispatchEvent(new CustomEvent('app-history-change'));
};

['pushState', 'replaceState'].forEach(methodName => {
	const original = history[methodName as HistoryMethod];
	history[methodName] = function (data, title, url) {
		const result = original.apply(this, [data, title, url]);
		emitHistoryChange();
		return result;
	};
});
